import { StyleSheet, PixelRatio, Dimensions } from "react-native"
import Colors from "constants/Colors"
import { listItemText } from "constants/Fonts"
import FontSizes from "constants/FontSizes"

const { width } = Dimensions.get("window")

export default StyleSheet.create({
  formItem: {
    width,
    backgroundColor: Colors.contentBackground,
    height: 50,
    marginLeft: 0,
    paddingLeft: 15,
    borderRadius: 0,
    borderColor: Colors.borderColor,
    borderTopWidth: 1 / PixelRatio.getPixelSizeForLayoutSize(1),
    borderBottomWidth: 1 / PixelRatio.getPixelSizeForLayoutSize(1),
  },
  inputText: {
    ...listItemText,
    fontSize: FontSizes.questionPlaceholderSize,
    color: Colors.textColor,
  },
  inputPlaceholder: {
    ...listItemText,
    fontSize: FontSizes.questionPlaceholderSize,
  },
  pickerInput: {
    width,
    paddingLeft: 0,
  },
})
